import { useModalBox } from '../../contexts'
import { Container } from './styles'

type Props = {
  title: string;
  description: string;
  isShowing?: boolean;
  color?: string;
}

const MissionInfo = ({ title, description, color, isShowing = true }: Props) => {
  const { modalBox } = useModalBox()

  function handleOpenModal () {
    modalBox(description, title)
  }

  return <Container isShowing={isShowing} onClick={handleOpenModal} color={color}>?</Container>
}
export default MissionInfo
